import { TablePagination, Box, CircularProgress, Container, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import Select from 'react-select';
import Nodo from './Nodo';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


class Organigrama extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,
            loading: false,
            consulta: false,
            busqueda: {
                departamento: '',
            },
            departamentos: [],
            filteredDepartamentos: [],
            departamento: [
                {id: 1, idLugaresTrabajo: '', lugar: '', departamento: ''}
            ],
            nextId: 2,
            ubicacionesCentral: [],
            consultaRealizada: false,
            data: null,
        }

        this.manejarConsultar = this.manejarConsultar.bind(this);
    }

    async componentDidMount(){
        const p = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajoSinN.php`);
        const datoDepartamento = await p.json();
        this.setState({
            departamentos: datoDepartamento,
        });

        this.setState({ filteredDepartamentos: datoDepartamento });

        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });
    }

    handleSelectChangeDepartamento = (selectedOption, rowIndex) => {
        const { departamento } = this.state;
        const updatedRows = [...departamento];
        updatedRows[rowIndex].departamento = selectedOption;
        this.setState({ departamento: updatedRows });
    };

    handleChangeDeptos = (index, e) => {
        const { name, value } = e.target;
        const { departamento } = this.state;
        const newRows = [...departamento];
        newRows[index][name] = value;
        this.setState({ departamento: newRows });
    };

    handleAddRowCal = () => {
        const { departamento, nextId } = this.state;
        const newRow = { id: nextId, idLugaresTrabajo: '', lugar: '', departamento: ''};
        this.setState({
            departamento: [...departamento, newRow],
            nextId: nextId + 1,
         });
    };

    handleRemoveRowDepartamento = (index) => {
        const { departamento } = this.state;
        if (departamento.length > 1) {
          const newRows = departamento.filter((row, i) => i !== index);
          this.setState({ departamento: newRows });
        }
    };

    render(){
        const { departamento } = this.state;
        const { filteredDepartamentos, searchInput } = this.state;
        const options = filteredDepartamentos.map(depto => ({
            value: depto.idLugaresTrabajo,
            label: depto.lugar
        }));
        return (
            <>
                <h3>Organigrama</h3>
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                {this.state.consulta || this.state.consultaRealizada
                ?
                    null
                :
                    <Container>
                        <Table style={{marginTop: '0.5rem', marginLeft: '14rem'}} sx={{maxWidth: 700}} id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell style={{textAlign: 'center'}}>Departamento</StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}></StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {departamento.map((row, index) => (
                                    <StyledTableRow key={row.id}>
                                        <StyledTableCell>
                                            <Select style={{width:"100%", border:"2px solid #D6EAF8"}} options={options} value={row.departamento} onChange={(selectedOption) => this.handleSelectChangeDepartamento(selectedOption, index)} />
                                        </StyledTableCell>
                                        {row.departamento !==  ''
                                        ?
                                            row.departamento.value === 0
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}}  name="lugar" value={row.lugar} onChange={(e) => this.handleChangeDeptos(index, e)}>
                                                        <option value={''}></option>
                                                        {this.state.ubicacionesCentral.map((name) =>
                                                            <option
                                                            key={name.idUbicacionesCentral}
                                                            value={name.idUbicacionesCentral}
                                                            >{name.descripcion}</option>
                                                            )}
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                <StyledTableCell></StyledTableCell>
                                        :
                                            <StyledTableCell></StyledTableCell>
                                        }
                                        <StyledTableCell> <button disabled={this.state.vieneControl} className="btn btn-outline-primary btn-sm mx-2" onClick={() => this.handleRemoveRowDepartamento(index)}>Eliminar</button> </StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <button className="btn btn-outline-primary btn-sm mx-2" style={{marginTop:'0.5rem'}} onClick={this.handleAddRowCal}>Agregar fila</button>
                        <button className="btn btn-outline-primary btn-sm mx-2" style={{marginTop:'0.5rem'}} onClick={this.manejarConsultar}>Consultar</button>
                    </Container>
                }
                {this.state.consultaRealizada
                ?
                    this.state.data && <Nodo data={this.state.data}/>
                :
                    null
                }
            </>
        )
    }

    async manejarConsultar(e){
        this.setState({
            errores: null,
            notificaciones: null,
            loading: true,
        })

        const cargaUtil = JSON.stringify([this.state.departamento]);
    
        const infoSol = await fetch(`${Constantes.RUTA_API}/consultar_organigrama.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await infoSol.json();

        this.setState({
            errores: res[0],
            loading: false,
        })

        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: null,
                data: res[1],
                consultaRealizada: true,
            })
        }
    }
}

export default Organigrama